import { motion } from "framer-motion";
import { useState } from "react";

export default function CustomTabs({ tabs, activeTab, setActiveTab }) {
  return (
    <div className="flex space-x-1 relative border-border-darkNew border p-1 rounded-lg mb-8">
      {tabs?.map((tab) => (
        <button
          key={tab?.value}
          onClick={() => setActiveTab(tab?.value)}
          className={`flex-1 font-N_Bold relative rounded-md px-3 py-1.5 text-base text-white transition `}
          style={{
            WebkitTapHighlightColor: "transparent",
          }}
        >
          {activeTab === tab?.value && (
            <motion.span
              layoutId="bubble"
              className="absolute inset-0 z-[1] font-N_Bold bg-primary  rounded-md"
              transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
            />
          )}
          <span
            className={`relative z-[2] font-N_Roman ${
              activeTab !== tab?.value && "text-white-opacity"
            }`}
          >
            {tab?.label}
          </span>
        </button>
      ))}
    </div>
  );
}
